import { ProhibitIcon } from "@phosphor-icons/react";

import { DENIAL_COPY, type RouteDenialReason } from "./route-access";

type AccessDeniedScreenProps = {
  reason: RouteDenialReason;
};

/**
 * The screen a denied route draws. It states what happened and what to do next
 * without naming the role that would have worked, without a diagnostic code,
 * and without a retry control, because retrying changes nothing here.
 *
 * The state is carried by the heading text and the icon shape, never by colour
 * alone (WCAG 2.2 AA, 1.4.1 Use of Colour).
 */
export function AccessDeniedScreen({ reason }: AccessDeniedScreenProps) {
  const { description, title } = DENIAL_COPY[reason];

  return (
    <section
      aria-labelledby="access-denied-title"
      className="max-w-2xl rounded-panel bg-surface-raised p-7 shadow-panel sm:p-9"
      data-denial-reason={reason}
    >
      <span aria-hidden="true" className="grid size-12 place-items-center rounded-full bg-surface-muted">
        <ProhibitIcon className="size-6 text-text-muted" weight="duotone" />
      </span>
      <h1 className="mt-5 text-2xl font-bold tracking-tight" id="access-denied-title">
        {title}
      </h1>
      <p className="mt-3 max-w-xl leading-7 text-text-muted">{description}</p>
    </section>
  );
}
